import React from "react";
import { Stack } from "@mui/material";

export default function MasterToolbar({
  children,
  compact = false,
}: {
  children: React.ReactNode;
  compact?: boolean;
}) {
  return (
    <Stack
      direction={compact ? "column" : "row"}
      spacing={1}
      useFlexGap
      flexWrap="wrap"
      alignItems={compact ? "stretch" : "center"}
      justifyContent={compact ? "flex-start" : "flex-end"}
      sx={{
        flex: "1 1 auto",
        width: compact ? "100%" : "auto",
        maxWidth: "100%",
        minWidth: 0,
        marginLeft: compact ? 0 : "auto",
      }}
    >
      {children}
    </Stack>
  );
}
